import Wrapper from "components/blocks/Wrapper";
import Container from "components/blocks/Container";
import DefaultLayout from "layouts/Default";
import {wrapper} from "lib/store";
import {getDealsByProductCategory} from "lib/services/deals";
import ProductListing from "components/views/ProductListing";
import React, {useEffect, useState} from "react";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {useTranslation} from "next-i18next";
import {getPaginatedBrandsThunk} from "lib/features/brandSlice";
import {getPaginatedProductsThunk} from "lib/features/productSlice";

export const getServerSideProps = wrapper.getServerSideProps(store => async (context) => {
  const allDeals = await getDealsByProductCategory()
  const {
    query,locale,
  } = context
  const {
    page = 1,
    sort = {},
    deals = [],
    categories = [],
    brandVerified = false,
    brands = [],
    strainTypes = [],
    priceRanges = [],
    weights = [],
    categorySlug
  } = query

  const filter = {
    deals,
    categories,
    brandVerified,
    brands,
    strainTypes,
    priceRanges,
    weights,
  }

  await store.dispatch(getPaginatedProductsThunk({page, filter, sort}))


  return {
    props: {
      allDeals,
      // allBrands,
      categorySlug,
      page,
      filter,
      sort,
      ...(await serverSideTranslations(locale, ['home', 'common']))
    }
  }
})

export default function CategorySlug(props) {
  const {
    categorySlug,
    page: _page,
    filter: _filter,
    sort: _sort,
    allDeals: deals,
  } = props
  const { t } = useTranslation()
  let products  = useSelector(state => state.product.products, shallowEqual)
  let brands = useSelector(state => state.brand.brands, shallowEqual)
  const [localFilter, setLocalFilter] = useState(_filter)
  const dispatch = useDispatch()
  const [loaded, setLoaded] = useState(false)
  const [localBrands, setLocalBrands] = useState(brands)

  async function initBrand() {
    await dispatch(getPaginatedBrandsThunk({_page, _filter, _sort}))
  }

  const reInitFilter = () => {
    let tempFilter = localFilter
    tempFilter.categories = []
    tempFilter.categories.push(categorySlug)
    setLocalFilter(tempFilter)
  }

  useEffect(() => {
    reInitFilter()
  }, [_filter])


  useEffect(() => {
    if (brands[0].name === 'Test') {
      initBrand()
    } else {
      setLoaded(true)
      setLocalBrands(brands.slice(brands.length - 5,brands.length))
    }
    return () => {
      console.log('clean up initBrand')
    }

  }, [brands])




  return (
    <Wrapper>
      {
        loaded ?
            <Container>
              <ProductListing
                  _filter={localFilter} _page={_page} _sort={_sort}
                  products={products} deals={[]} brands={localBrands}
                  baseUrl={`/products/${categorySlug}`}
                  type={'Product'} category={categorySlug}
              />
            </Container> :
            <Container style={{ marginTop: 50 }}>
              <span>{t('home:loading')}</span>
            </Container>
      }
    </Wrapper>
  )
}


CategorySlug.getLayout = function getLayout(page) {
  return (
    <DefaultLayout>
      {page}
    </DefaultLayout>
  )
}
